import { LeadImportInput } from './leadImportInput';

export class LeadsImportInput {
  leadsImport: LeadImportInput[] = [];
}
